import React from "react";
import styles from "./MostPopularProducts.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFire, faStar, faEye } from "@fortawesome/free-solid-svg-icons";

const MostPopularProducts = ({ initailData }: any) => {
  const calculateDiscount = (price: number, ourPrice: number) => {
    return Math.round(((price - ourPrice) / price) * 100);
  };

  // Get most popular products based on discount and ourPrice
  const getPopularProducts = () => {
    // Flatten all models from all series
    const allModels = initailData.flatMap((series: any) =>
      series.models.map((model: any) => ({
        ...model,
        seriesId: series?.id,
        seriesTitle: series?.title,
        discount: calculateDiscount(model?.price, model?.ourPrice),
      }))
    );

    // Sort by discount (descending) and then by ourPrice (descending)
    const sortedModels = [...allModels].sort((a, b) => {
      if (b.discount !== a.discount) {
        return b.discount - a.discount;
      }
      return b.ourPrice - a.ourPrice;
    });

    // Take top 4 products
    return sortedModels.slice(0, 6).map((product, index) => ({
      ...product,
      rating: 5 - index * 0.2, // Generate decreasing rating (5, 4.8, 4.6, etc.)
      views: 10000 - index * 2000, // Generate decreasing views
    }));
  };

  const popularProducts = getPopularProducts();

  if (popularProducts.length === 0) {
    return <div>No popular products found</div>;
  }

  return (
    <section className={styles.popularSection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>
          <FontAwesomeIcon icon={faFire} className={styles.fireIcon} />
          Most Popular in Commercial Spaces
        </h2>
        <p className={styles.sectionSubtitle}>
          Discover what businesses across India are choosing for their premium
          interiors
        </p>
      </div>

      <div className={styles.productsGrid}>
        {popularProducts.map((product, index) => (
          <div key={product._id} className={styles.productCard}>
            <div className={styles.productImageContainer}>
              <img
                src={product.picture[0]?.path || ""}
                alt={product.name}
                className={styles.productImage}
                loading="lazy"
              />
              <div className={styles.popularBadge}>
                <FontAwesomeIcon icon={faFire} />
                <span>
                  #{index + 1} in {product.seriesTitle}
                </span>
              </div>
            </div>
            <div className={styles.productInfo}>
              <h3 className={styles.productTitle}>{product.name}</h3>
              <p className={styles.productSeries}>{product.seriesTitle}</p>
              <div className={styles.priceInfo}>
                <span className={styles.originalPrice}>₹{product.price}</span>
                <span className={styles.ourPrice}>₹{product.ourPrice}</span>
                <span className={styles.discount}>{product.discount}% OFF</span>
              </div>
              <div className={styles.statsContainer}>
                <div className={styles.statItem}>
                  <FontAwesomeIcon icon={faStar} className={styles.statIcon} />
                  <span>{product.rating.toFixed(1)}/5</span>
                </div>
                <div className={styles.statItem}>
                  <FontAwesomeIcon icon={faEye} className={styles.statIcon} />
                  <span>{product.views.toLocaleString()} views</span>
                </div>
              </div>
              <a
                href={`/series/${product.seriesId}/product/${product._id}`}
                className={styles.viewButton}
              >
                View Details
              </a>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.viewAllContainer}>
        <a href="/gallery" className={styles.viewAllButton}>
          Explore All Collections
        </a>
      </div>
    </section>
  );
};

export default MostPopularProducts;
